import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "filename"]

  connect() {
    if (this.hasInputTarget && this.hasPreviewTarget) {
      this.inputTarget.addEventListener("change", this.preview.bind(this))
    }
  }

  preview() {
    this.clearPreviews()

    if (this.inputTarget.files.length === 0) {
      return
    }

    Array.from(this.inputTarget.files).forEach(file => {
      if (file.type.startsWith("image/")) {
        const reader = new FileReader()
        reader.onload = (event) => {
          const img = document.createElement("img")
          img.src = event.target.result
          img.classList.add("h-24", "w-24", "object-cover", "rounded-md", "shadow-sm", "m-1")
          this.previewTarget.appendChild(img)
        }
        reader.readAsDataURL(file)
      }
      
      if (this.hasFilenameTarget) {
        const fileNameSpan = document.createElement("span")
        fileNameSpan.textContent = file.name
        fileNameSpan.classList.add("text-sm", "text-gray-600", "block", "mt-1")
        this.filenameTarget.appendChild(fileNameSpan)
      }
    })
  }

  clearPreviews() {
    this.previewTarget.innerHTML = ""
    if (this.hasFilenameTarget) {
      this.filenameTarget.innerHTML = ""
    }
  }
}
